var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isListenerMobile)?_c('ListenerGenreLibrary'):_c('GenreLibrary')
}
var staticRenderFns = []

export { render, staticRenderFns }